export default __webpack_public_path__ + "static/media/frame.6d8e8926.png";